import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
// Services';
import { GenericFormService } from '../service/generic-form.service';
import { FieldModel } from '../model/field.model';

@Component({
	selector: 'cv-form-input',
	templateUrl: './input-field.component.html',
	styleUrls: [ './input-field.component.scss' ]
})
export class FormInputFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	@Input() show: any;
	@Input() active = false;

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	highlight = '';
	temporalInputId = Date.now();
	keyCodes: number[] = [8, 38, 40, 189, 190, 109, 110];
	min: any;
	max: any;

	constructor(
		private formService: GenericFormService
	) {
		//
	}

	ngOnInit(): any {
		if ('onlyDigits' in this.fieldOptions && this.fieldOptions.onlyDigits) {
			this.keyCodes = [8, 38, 40];
		}

		if ('min' in this.fieldOptions) {
			this.min = this.fieldOptions.min;
		}

		if ('max' in this.fieldOptions) {
			this.max = this.fieldOptions.max;
		}

		if (this.field.disabled) {
			this.control.disable();
		}
	}

	/**
	 * validates form on input blur
	 * @param event
	 */
	async onChange(event: any): Promise<void> {
		if (this.control.parent) {
			// console.log(this.control.value);
			if (
				(['Text', 'String'].indexOf(this.field.DataType) > -1)
				&& this.control.value !== null
				&& this.control.value !== this.control.value.trim()
			) {
				this.control.setValue(this.control.value.trim());
			}

			if ((['Integer', 'Numeric'].indexOf(this.field.DataType) > -1)) {
				let number = parseFloat(this.control.value);
				if (this.max && number > this.max) {
					number = this.max;
				}

				this.control.setValue(number);
			}

		}

		if(this.field?.UIEvents?.onChangeText) {
			this.formService.onChangeText$.next({
				field: this.field,
				fieldOptions: this.fieldOptions,
				event: {
					eventName: 'onChangeText',
					data: this.control.value
				}
			});
		}
	}

	/**
	 * validates form on input keyup
	 * @param event
	 */
	async onKeyup(event: any): Promise<void> {
		if (this.control.parent) {
			if (this.control.dirty) {
				this.formService.validate(this.control);
			}
		}
	}

	onKeyDownNumeric(event: any): boolean {
		if (event.keyCode === 9) {
			return true;
		}
		if (
			(event.keyCode > 95 && event.keyCode < 106) ||
			(event.keyCode > 47 && event.keyCode < 58) ||
			this.keyCodes.includes(event.keyCode)
		) {
			this.onKeyup(event);
			return true;
		}
		return false;
	}
}
